import { createReducer, on } from '@ngrx/store';
import * as actions from './shared.actions';
import { createInitialSharedState } from './shared.state';

export const sharedReducer = createReducer(
    createInitialSharedState(),

    on(actions.setTableRefresher, (state, newState) => ({
        ...state,
        tableRefresher: {
            ...state.tableRefresher,
            [newState.table]: newState.actions || [],
        },
    })),
);
